<template>
  <div
    class="sendMessgeBox"
    style="background: #fff"
    :style="{ minHeight: screenHeight - 151 + 'px' }"
  >
    <div class="flex_jus_cen">
      <h3 class>{{ content.messageTitle }}</h3>
    </div>
    <div class="flex_between mt10">
      <div class="flex_align">
        <div class="spans">发起人：{{ content.createBy }}</div>
        <div class="spans ml90">发起时间：{{ content.createTime }}</div>
      </div>
      <div class="flex_align" v-if="!showRead">
        <div class="spans">知会状态：</div>
        <div class="co_169 pointer" @click="showisRead">
          {{ content.haveReadNumber }}/{{ content.totalNumber }}
        </div>
      </div>
    </div>
    <div class="minHeight mt10">
      <div v-html="content.messageContent"></div>
    </div>
    <div class="flex_jus_cen mt10 mb10" v-if="!preview">
      <el-button plain @click="returnList" size="mini">返回消息列表</el-button>
      <el-button
        type="primary"
        @click="read"
        v-if="showRead && isFeedbackShow"
        :disabled="isdisabled"
        size="mini"
        >{{ isread }}</el-button
      >
      <el-button type="danger" @click="del" v-if="!showRead" size="mini"
        >删除</el-button
      >
    </div>
    <div class="flex_jus_cen mt10 mb10" v-if="preview">
      <el-button plain @click="previewBack" size="mini">返回</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="ReadDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      center
    >
      <div class="mt10 maxHeight">
        <div class="flex">
          <div class="co_c9 w80">未回执：</div>
          <div class="flex_warp w400">
            <div v-for="(item, index) in notRead" :key="index" class="ml10">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="flex mt10">
          <div class="co_c9 w80">已回执：</div>
          <div class="flex_warp w400">
            <div v-for="(item, index) in haveRead" :key="index" class="ml10">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "lookMessge",
  components: {},
  mounted() {},
  data() {
    return {
      ReadDialogVisible: false,
      screenHeight: document.documentElement.clientHeight, //屏幕高度
      content: "",
      messageId: "",
      isread: "我已知晓",
      isdisabled: false,
      preview: false,
      showRead: true,
      haveRead: [],
      notRead: [],
      isFeedbackShow: false,
    };
  },
  methods: {
    del() {
      let that = this;
      that.MGridUtil.MessageBox("确定删除这条消息吗？", function Sure() {
        // that
        //   .request(
        //     this.Appconstance.REQUEST_TYPE.GET,
        //     that.adminApi.homerenovation.deleteMessageById + that.messageId,
        //     {},
        //     false
        //   )
        //   .then(res => {
        //     if (res.status == 200) {
        //       that.MGridUtil.MessageShow("删除成功", "success");
        //       that.returnList();
        //     }
        //   });
      });
    },
    getMessgeInfo(id) {
      this.preview = false;
      this.messageId = id.messageId;
      if (id.isRead == 1) {
        this.isread = "已发回执";
        this.isdisabled = true;
      } else {
        this.isread = "我已知晓";
        this.isdisabled = false;
      }
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.selectById + id.messageId,
      //   false,
      //   true
      // ).then((res) => {
      //   this.content = res.rows[0];
      //   let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      //   if (this.content.sendId == userInfo.mapInfo.userId) {
      //     this.showRead = false;
      //   }
      //   if (this.content.isFeedback == 1) {
      //     this.isFeedbackShow = true;
      //   } else {
      //     this.isFeedbackShow = false;
      //     this.showRead = true;
      //   }
      // });
    },
    read() {
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.updateReadStatus + this.messageId,
      //   false,
      //   true
      // ).then((res) => {
      //   if (res.status == 200) {
      //     this.isread = "已发回执";
      //     this.isdisabled = true;
      //   }
      // });
    },
    returnList() {
      this.$emit("returnList", "list");
    },
    lookMessgeInfo(data) {
      this.preview = true;
      this.content = data;
    },
    previewBack() {
      this.$emit("previewBack", this.content);
    },
    showisRead() {
      let data = {};
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.GET,
      //   this.adminApi.homerenovation.selectViewDetailsById + this.messageId,
      //   false,
      //   true
      // ).then((res) => {
      //   if (res.status == 200) {
      //     this.haveRead = res.mapInfo.havaRead;
      //     this.notRead = res.mapInfo.notRead;
      //     this.ReadDialogVisible = true;
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  max-height: 100%;
}
.maxHeight {
  max-height: 600px;
  overflow: auto;
}
.w400 {
  max-width: 400px;
}
.ml10 {
  margin-left: 10px;
}
.w80 {
  width: 80px;
}
.flex_warp {
  display: flex;
  flex-wrap: wrap;
}
.co_c9 {
  color: #c9c9c9;
}
.pointer {
  cursor: pointer;
}
.minHeight {
  min-height: 600px;
}
.sendMessgeBox {
  padding: 30px;
}
.spans {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #a1a1a1;
}
.mt10 {
  margin-top: 10px;
}
.ml90 {
  margin-left: 90px;
}
.co_169 {
  font-family: "Microsoft YaHei";
  font-weight: 700;
  color: #169bd5;
}
.mb10 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/lookMessge.vue